export const MODULES_OUTCOME = '/modules-outcome'
